/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    VccCredentialsListConfiguration,
    VccCredentialsListConfigurationFromJSON,
    VccCredentialsListConfigurationToJSON,
    VccCredentialsListItem,
    VccCredentialsListItemFromJSON,
    VccCredentialsListItemToJSON,
    VccCredentialsQuery,
    VccCredentialsQueryFromJSON,
    VccCredentialsQueryToJSON,
} from '../models';

export interface ApiVccCredentialsListListPostRequest {
    vccCredentialsQuery?: VccCredentialsQuery;
}

/**
 * no description
 */
export class VccCredentialsListApi extends runtime.BaseAPI {

    /**
     */
    async apiVccCredentialsListConfigurationGetRaw(): Promise<runtime.ApiResponse<VccCredentialsListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VccCredentialsListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiVccCredentialsListConfigurationGet(): Promise<VccCredentialsListConfiguration> {
        const response = await this.apiVccCredentialsListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiVccCredentialsListListPostRaw(requestParameters: ApiVccCredentialsListListPostRequest): Promise<runtime.ApiResponse<Array<VccCredentialsListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsList/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VccCredentialsQueryToJSON(requestParameters.vccCredentialsQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VccCredentialsListItemFromJSON));
    }

    /**
     */
    async apiVccCredentialsListListPost(requestParameters: ApiVccCredentialsListListPostRequest): Promise<Array<VccCredentialsListItem>> {
        const response = await this.apiVccCredentialsListListPostRaw(requestParameters);
        return await response.value();
    }

}
